export default {
  SET_CLUSTER_DATA_MIDDLEWARE(state, payload) {
      state.clusterDataMiddleware = payload;
  },
  SET_REPORTS_PROJ_MIDDLEWARE(state, payload) {
      state.reportsProjMiddleware = payload.reportsProj;
  },
  SET_PROJECTS_CLUST_MIDDLEWARE(state, payload) {
    state.projectsClustMiddleware = payload;
  },
  SET_EXTRACTED_DATA_BINARY_MIDDLEWARE(state, payload) {
    state.extractedDataBinaryMiddleware = payload;
  },
  SET_DRAW_CIRCUIT_MIDDLEWARE(state, payload) {
    state.drawCircuitMiddleware = payload;
  },
  SET_RECOMMEND_CIRCUIT_MIDDLEWARE(state, payload) {
    state.apiRecommendCircuitMiddleware = payload;
  },
  SET_NEW_TEMPLATE_DB_MIDDLEWARE(state, payload) {
    state.newTemplateMiddleware = payload;
  },
  SET_USERS_SHARING_MIDDLEWARE(state, payload) {
    state.usersSharingMiddleware = payload.usersSharing;
  },
  LAST_ERROR_MIDDLEWARE(state, lastError) {
    state.lastErrorMiddleware = lastError;
  },
  SET_TEMPLATE_DB_MIDDLEWARE(state, payload) {
    state.templateDBMiddleware = payload;
  },
  SET_PROJ_TEMPLATES_LIST_MIDDLEWARE(state, payload) {
    state.projTemplListMiddleware = payload;
  },
  SET_TEMPLATES_LIST_MIDDLEWARE(state, payload) {
    state.templListMiddleware = payload;
  },
	SET_FETCH_ACCESS_REQUESTSS_MIDDLEWARE(state, payload){
		state.resourceAccessRequestsMiddleware = payload;
	},
	SET_TOTAL_PENDING_RESOURCE_REQUESTSS_MIDDLEWARE(state, payload){
		state.totalIncomingPendingAccessRequestsMiddleware = payload.totalIncomingPendingRequests;
		state.totalPersonalPendingAccessRequestsMiddleware = payload.totalPersonalPendingRequests;
	},
	SET_REPORT_ACCESS_TYPE_MIDDLEWARE(state, payload) {
		state.reportAccessTypeMiddleware = payload.responseData;
},
}
